import Lookup from './lookup.js';

export default class TypeInjury extends Lookup
{
    
}
